import React from 'react';

const Footer = () => {
    return (
        <div className="footer text-center py-6">
            <p>&copy; {new Date().getFullYear()} Digital Electronic</p>
        </div>
    );
};

export default Footer;
